import { SetDefaultPaymentOptions } from '../../Actions/setDefaultPaymentOptions/setDefaultPaymentOptions';

export const batchSetDefaultPaymentOptions = (
  setDefaultPaymentOptions: SetDefaultPaymentOptions,
): SetDefaultPaymentOptions => {
  let batch: Parameters<SetDefaultPaymentOptions>[0] | undefined;
  return (dataToUpdate) => {
    if (!Object.keys(dataToUpdate).length) {
      return;
    }
    if (!batch) {
      batch = {};
      Promise.resolve().then(() => {
        const dataToApply = batch!;
        batch = undefined;
        setDefaultPaymentOptions(dataToApply);
      });
    }
    Object.assign(batch, dataToUpdate);
  };
};
